
type NavbarAuthProps = {
  hasToken: boolean;
  authMode?: 'split' | 'signin';
  onDashboard: () => void;
  onLogin: () => void;
  onSignup: () => void;
};

export function NavbarAuth({
  hasToken,
  onDashboard,
  onLogin,
  onSignup,
}: NavbarAuthProps) {
  if (hasToken) {
    return (
      <button
        type="button"
        onClick={onDashboard}
        className="landing-nav-grad-btn landing-nav-auth-dashboard"
        style={{
          background: 'linear-gradient(135deg, #3B66B8 0%, #8156B4 100%)',
          color: '#fff',
          borderRadius: 999,
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          fontWeight: 700,
          boxShadow: '0 10px 24px rgba(80, 60, 170, 0.16)',
        }}
      >
        Dashboard
      </button>
    );
  }

  return (
    <>
      <button
        type="button"
        onClick={onLogin}
        className="landing-nav-auth-signin"
        style={{
          color: '#3A3660',
          background: 'transparent',
          border: 'none',
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          fontWeight: 700,
        }}
      >
        Sign In
      </button>
      <button
        type="button"
        onClick={onSignup}
        className="landing-nav-grad-btn landing-nav-auth-signup"
        style={{
          background: 'linear-gradient(135deg, #3B66B8 0%, #8156B4 100%)',
          color: '#fff',
          borderRadius: 999,
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          fontWeight: 700,
          boxShadow: '0 10px 24px rgba(80, 60, 170, 0.16)',
        }}
      >
        Sign Up
      </button>
    </>
  );
}
